import { PropositionButtonSchema } from '@/views/sports/components/PropositionButton/styles/PropositionButton.styles';

export const propositionButtonStyles: PropositionButtonSchema = {
  buttonBase: {
    variant: 'odds',
  },
  buttonBaseSpanProps: {
    overflow: 'hidden',
    pos: 'relative',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    alignSelf: 'center',
    textTransform: 'capitalize',
    fontWeight: 'extrabold',
    fontFamily: 'body',
    fontSize: '2xs',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.35)',
  },
  buttonBaseBox: {
    fontSize: 'sm',
    fontWeight: 'normal',
    fontFamily: 'accentStaat',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.35)',
  },
  textBase: {
    textAlign: 'center',
    color: 'beta.600',
  },
};
